import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/platform-browser';
import {Angulartics2} from 'angulartics2';
import {LinenotificationService} from './linenotification.service';

@Injectable()
export class TrackingServiceService {

    constructor(private angulartics2: Angulartics2, private lineNoti: LinenotificationService, @Inject(DOCUMENT) private document: any) {
    }

    async eventTracking(action, category, label) {
        if (this.document.location.hostname !== 'localhost') {
            (<any>window).gtag('event', action, {
                'event_category': category,
                'event_label': label
            });

            await this.lineNoti.sendNoti({
                action: action,
                category: category,
                label: label
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/tracking-service.service.ts